<nb-route-tabset [tabs]="tabs" fullWidth></nb-route-tabset>
